import { Icon } from '@openedx/paragon';
import { RiBookOpenLine } from '@remixicon/react';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from './messages';
import OngoingCourseCard from './OngoingCourseCard';

const OngoingCoursesSection = ({ items }) => {
  const intl = useIntl();

  if (!items || items.length < 1) {
    return null;
  }

  return (
    <section className="ongoing-courses-section">
      <div className="ongoing-courses-section__header">
        <div className="ongoing-courses-section__headerRow">
          <Icon className="ongoing-courses-section__headerIcon" src={RiBookOpenLine} size="sm" />
          <div className="ongoing-courses-section__title">{intl.formatMessage(messages.ongoingCourses)}</div>
        </div>
        <div className="ongoing-courses-section__subtitle">
          {intl.formatMessage(messages.ongoingCoursesSubtitle)}
        </div>
      </div>

      <div className="ongoing-courses-section__scrollWrapper">
        <div className="ongoing-courses-section__scroll" aria-label={intl.formatMessage(messages.ongoingCoursesListLabel)}>
          {items.map((item) => (
            <OngoingCourseCard key={item.id} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OngoingCoursesSection;

